import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { createRoot } from 'react-dom/client';
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
